import { IconDefinition } from "./types";

const sparkles: IconDefinition = {
  iconName: "sparkles",
  width: 640,
  height: 512,
  svgPathData:
    "M480 32l-72 32 72 32 32 72 32-72 72-32-72-32-32-72-32 72zM288 320c60.9-27.1 108.9-48.4 144-64-35.1-15.6-83.1-36.9-144-64-27.1-60.9-48.4-108.9-64-144-15.6 35.1-36.9 83.1-64 144-60.9 27.1-108.9 48.4-144 64 35.1 15.6 83.1 36.9 144 64 27.1 60.9 48.4 108.9 64 144 15.6-35.1 36.9-83.1 64-144zm-64 25.8c-15.5-34.9-24.7-55.7-27.6-62.2-6.5-2.9-27.2-12.1-62.2-27.6 34.9-15.5 55.7-24.7 62.2-27.6 2.9-6.5 12.1-27.2 27.6-62.2 15.5 34.9 24.7 55.7 27.6 62.2 6.5 2.9 27.2 12.1 62.2 27.6-34.9 15.5-55.7 24.7-62.2 27.6-2.9 6.5-12.1 27.2-27.6 62.2zM480 344l-32 72-72 32 72 32 32 72 32-72 72-32-72-32-32-72z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "sparkles",
  unicode: 0xf890,
};

export { sparkles };
